// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".postal-input .el-input__inner::-moz-placeholder{color:#666;opacity:1!important}.postal-input .el-input__inner::placeholder{color:#666;opacity:1!important}.postal-input.large .el-button,.postal-input.large .el-input__inner{height:3.2rem}.postal-input.large .el-input__inner{padding-left:40px}.postal-input.large .el-input__prefix{width:35px}.postal-input .el-input__inner{padding-left:35px}.postal-input .el-input__prefix{width:30px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
